const initState = () => ({
  loterys: [],
});

export default initState;
